import React from "react";
import { Navigate } from "react-router-dom";
import { INTERIOR_DESIGN_HOME, PARTNER_HOME, useResolvedPartnerService } from "../../utils/partnerService";

/**
 * Route guard by partner service type (service only, other roles are never touched).
 *   mode="standard"  -> property routes: an Interior Design partner is sent to the Catalog
 *   mode="interior"  -> catalog routes: any other PARTNER is sent to their dashboard
 * Renders nothing while the service is still being resolved, so neither page flashes.
 */
const PartnerServiceGuard = ({ mode, children }) => {
  const { kind, isPartner, isLoading } = useResolvedPartnerService();

  // Not a partner (customer, agent, admin, signed out): leave to the existing guards.
  if (!isPartner) return children;
  if (isLoading) return null;

  if (mode === "standard" && kind === "interior") {
    return <Navigate to={INTERIOR_DESIGN_HOME} replace />;
  }
  if (mode === "interior" && kind !== "interior") {
    return <Navigate to={PARTNER_HOME} replace />;
  }
  return children;
};

export default PartnerServiceGuard;
